import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Field } from 'react-final-form-html5-validation';
import * as actions from '../../actions';
import { isRequiredQuestionSelection, isRequiredText, validateEmailSignup } from '../helpers/Validation';


class Step1 extends Component {

    render() {
        const { drp } = this.props;
        const { emailAddress } = this.props;
        const { selectedUser, takingNuplazid } = this.props.questionOptions;
        return (
            <Fragment>
                <div className="form-group">
                    <Field className="form-control full-width-input" name="special" component="input">
                        {({ input, meta }) => (
                            <Fragment>
                                <input {...input}  type="text" style={{opacity: 0, height:"0px"}} tabIndex="-1" />
                            </Fragment>
                        )}
                    </Field>
                    <div className="grid">
                        <div className="row">
                            <div className="col-lg-12">
                                <p>Sign up to receive additional information that could help you or your loved one navigate {drp ? "dementia-" : "Parkinson's disease (PD)–"}related hallucinations and delusions.  Our emails cover a variety of topics, including identifying PD-related hallucinations and delusions, talking with your healthcare provider at the first signs of symptoms, starting NUPLAZID, financial support, and more.</p>
                                <p style={{margin: "50px 0px 0px",fontWeight: "bold", fontSize: "20px"}}>Which statement best describes&nbsp;you?</p>
                                <div className="grid relative">
                                    <div className="row gtm-crm-describe">
                                        <Field
                                            className="form-control full-width-input"
                                            defaultValue={selectedUser}
                                            name="selectedUser"
                                            component="input"
                                            type="hidden"
                                            validate={isRequiredQuestionSelection}
                                        >
                                            {({ input, meta }) => (
                                                <Fragment>
                                                    <input {...input}/>
                                                    {meta.error && meta.touched && meta.error }
                                                </Fragment>
                                            )}
                                        </Field>
                                        <div className="col-lg-6 col-sm-12">
                                            <button 
                                                className={"btn btn-primary large first btn-lg w-auto text-center wide-mobile "  + (selectedUser === "caregiver" ? "active" : "") + (drp ? " drp-button" : " pdp-button")}
                                                type="button" 
                                                onClick={(e) => this.props.questionAnswer("selectedUser", "caregiver")}
                                            >
                                                <b>I am caring for someone with&nbsp;{drp ? "dementia" : "PD"}</b>
                                            </button>
                                        </div>
                                        <div className="col-lg-6 col-sm-12">
                                            <button 
                                                className={"btn btn-primary large first btn-lg w-auto text-center wide-mobile "  + (selectedUser === "patient" ? "active" : "") + (drp ? " drp-button" : " pdp-button")}
                                                type="button" 
                                                onClick={(e) => this.props.questionAnswer("selectedUser", "patient")}
                                            >
                                                <b>I am living with {drp ? "dementia" : "PD"}</b>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="row gtm-crm-nuplazid">
                                    <div className="col-lg-12">
                                        <p style={{margin: "50px 0px 0px",fontWeight: "bold", fontSize: "20px"}}>Are you or the person you care for taking NUPLAZID?</p>
                                        <div className="grid relative">
                                            <div className="row">
                                                <Field className="form-control full-width-input" defaultValue={takingNuplazid} name="takingNuplazid" component="input" type="hidden" validate={isRequiredQuestionSelection}>
                                                    {({ input, meta }) => (
                                                        <Fragment>
                                                            <input {...input} />
                                                            {meta.error && meta.touched && meta.error }
                                                        </Fragment>
                                                    )}
                                                </Field>
                                                <div className="col-lg-6 col-sm-12">
                                                    <button 
                                                        className={"btn btn-primary large first btn-lg w-auto text-center wide-mobile "  + (takingNuplazid === "yes" ? "active" : "") + (drp ? " drp-button" : " pdp-button")}
                                                        type="button" 
                                                        onClick={(e) => this.props.questionAnswer("takingNuplazid", "yes")}
                                                    >
                                                        <b>Yes</b>
                                                    </button>
                                                </div>
                                                <div className="col-lg-6 col-sm-12">
                                                    <button 
                                                        className={"btn btn-primary large first btn-lg w-auto text-center wide-mobile "  + (takingNuplazid === "no" ? "active" : "") + (drp ? " drp-button" : " pdp-button")}
                                                        type="button"
                                                        onClick={(e) => this.props.questionAnswer("takingNuplazid", "no")}
                                                    >
                                                        <b>No</b>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <p style={{margin: "50px 0px 0px",fontWeight: "bold", fontSize: "20px"}}>Please enter your name and email address below.</p>
                                <div className="form-group relative">
                                    <Field 
                                        className="form-control full-width-input"
                                        name="firstName"
                                        component="input"
                                        type="text"
                                        validate={isRequiredText}
                                    >
                                        {({ input, meta }) => (
                                            <Fragment>
                                                <label className="text-left full-width full-width-input signup-label">First Name</label>
                                                <input className="form-control full-width-input signup-input" {...input} />
                                                {meta.error && meta.touched && meta.error }
                                            </Fragment>
                                        )}
                                    </Field>
                                </div>
                                <div className="form-group relative">
                                    <Field 
                                        className="form-control full-width-input"
                                        name="lastName"
                                        component="input"
                                        type="text"
                                        validate={isRequiredText}
                                    >
                                        {({ input, meta }) => (
                                            <Fragment>
                                                <label className="text-left full-width full-width-input signup-label">Last Name</label>
                                                <input className="form-control full-width-input signup-input" {...input} />
                                                {meta.error && meta.touched && meta.error }
                                            </Fragment>
                                        )}
                                    </Field>
                                </div>
                                <div className="form-group relative">
                                    <Field 
                                        className="form-control full-width-input"
                                        name="emailAddress"
                                        component="input"
                                        type="text"
                                        defaultValue={emailAddress}
                                        validate={validateEmailSignup}
                                    >
                                        {({ input, meta }) => (
                                            <Fragment>
                                                <label className="text-left full-width full-width-input signup-label">Email</label>
                                                <input className="form-control full-width-input signup-input" {...input} placeholder="Example: name@email.com" />
                                                {meta.error && meta.touched && meta.error }
                                            </Fragment>
                                        )}
                                    </Field>
                                </div>
                                <p>By clicking &ldquo;Submit,&rdquo; I understand and agree to the <a href="https://www.acadia-pharm.com/privacy/" className="signup-terms-and-privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a> and <a href="https://www.acadia-pharm.com/terms/" className="signup-terms-and-privacy" target="_blank" rel="noopener noreferrer">Terms of Use</a>. I&nbsp;agree to receive communications from Acadia Pharmaceuticals Inc.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}


const mapStateToProps = (state) => {
    const { questionOptions } = state;
    return { questionOptions: questionOptions };
}

export default connect(mapStateToProps, actions)(Step1);
